(function() {
	'use strict';

	var $ = avm.require('cash'),

		$expandMainButton = $('.js-main-btn-expand'),
		$closeMainButton = $('.js-main-btn-close'),
		$mainFeatures = $('.js-main-features-expand'),
		$closeButtons = $('.js-close'),
		$expandButtons = $('.js-expand');


	// Main Features panel togglers
	$expandMainButton.on('click', function() {
		var $self = $(this);
		$mainFeatures.toggleClass('expanded');
		$closeMainButton.toggleClass('d-none');
		$self.toggleClass('d-none');
	});
	$closeMainButton.on('click', function() {
		var $self = $(this);
		$mainFeatures.toggleClass('expanded');
		$expandMainButton.toggleClass('d-none');
		$self.toggleClass('d-none');
	});

	// Other Features panels togglers
	$expandButtons.on('click', function() {
		var $target = $(this).parent().prev();
		$(this).parent().toggleClass('d-none');
		$target.toggleClass('expanded');
	});
	$closeButtons.on('click', function() {
		var $target = $(this).parent().next();
		$(this).parent().toggleClass('expanded');
		$target.toggleClass('d-none');
	});

	// remove onclick js attribut function
	$('.btn-hint a').prop("onclick", null).off("click");

})();
